import { useScopedTranslate } from '@locale/translate';

const translations = {
  en: {
    placeholder: 'Upload file',
    accepted: 'Accepted file types:',
  },
  is: {
    placeholder: 'Bæta við skrá',
    accepted: 'Leyfðar skráartegundir:',
  },
  dk: {
    placeholder: 'Vælg fil',
    accepted: 'Accepterede filtyper:',
  },
};

export const useFileTranslations = () => useScopedTranslate(translations);
